import { render, staticRenderFns } from "./SyslogServer.vue?vue&type=template&id=569ce588&scoped=true"
import script from "./SyslogServer.vue?vue&type=script&lang=js"
export * from "./SyslogServer.vue?vue&type=script&lang=js"
import style0 from "./SyslogServer.vue?vue&type=style&index=0&id=569ce588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569ce588",
  null
  
)

export default component.exports